import { useEffect, useMemo, useRef, useState } from 'react';



import { APP_TITLE } from '../config/appBranding';

const DEFAULT_TITLE = APP_TITLE;

const ALERT_MESSAGE = '有新的待处理任务';



function snapshotBadge(badge) {

  if (!badge) return { approve: 0, cc: 0, execute: 0, initiated: 0 };

  return {

    approve: badge.approve || 0,

    cc: badge.cc || 0,

    execute: badge.execute || 0,

    initiated: badge.initiated || 0

  };

}



function hasActionablePending(badge) {

  const snap = snapshotBadge(badge);

  return snap.approve > 0 || snap.cc > 0 || snap.execute > 0 || snap.initiated > 0;

}



/** 任一待办维度较基线增加，视为有新任务 */

function badgeIncreased(current, baseline) {

  if (!baseline) return false;

  const cur = snapshotBadge(current);

  return cur.approve > baseline.approve

    || cur.cc > baseline.cc

    || cur.execute > baseline.execute

    || cur.initiated > baseline.initiated;

}



/**

 * 有待办时在浏览器标签滚动展示提醒文案。

 * 仅当标签页不可见且待办数量较上次「已读」基线增加时提醒；

 * 用户切回标签页后恢复默认标题，已有待办不再重复提醒。

 */

export function useDocumentTitleAlert(enabled, badge) {

  const baselineRef = useRef(null);

  const initializedRef = useRef(false);

  const [tabVisible, setTabVisible] = useState(

    () => typeof document !== 'undefined' && document.visibilityState === 'visible'

  );



  useEffect(() => {

    const syncVisible = () => {

      setTabVisible(document.visibilityState === 'visible');

    };

    document.addEventListener('visibilitychange', syncVisible);

    window.addEventListener('focus', syncVisible);

    return () => {

      document.removeEventListener('visibilitychange', syncVisible);

      window.removeEventListener('focus', syncVisible);

    };

  }, []);



  useEffect(() => {

    if (!enabled) {

      initializedRef.current = false;

      baselineRef.current = null;

      document.title = DEFAULT_TITLE;

      return;

    }



    const snap = snapshotBadge(badge);

    if (!initializedRef.current) {

      baselineRef.current = snap;

      initializedRef.current = true;

      return;

    }



    if (tabVisible) {

      baselineRef.current = snap;

    }

  }, [enabled, badge, tabVisible]);



  const shouldAlert = useMemo(() => {

    if (!enabled || !hasActionablePending(badge) || tabVisible) return false;

    return badgeIncreased(badge, baselineRef.current);

  }, [enabled, badge, tabVisible]);



  useEffect(() => {

    if (!shouldAlert) {

      document.title = DEFAULT_TITLE;

      return undefined;

    }



    const scrollText = `${ALERT_MESSAGE}　—　${DEFAULT_TITLE}　—　`;

    let pos = 0;

    const visibleLen = Math.max(DEFAULT_TITLE.length, ALERT_MESSAGE.length + 2);



    const tick = () => {

      const slice = scrollText.slice(pos, pos + visibleLen);

      document.title = slice.length < visibleLen

        ? `${slice}${scrollText.slice(0, visibleLen - slice.length)}`

        : slice;

      pos = (pos + 1) % scrollText.length;

    };



    tick();

    const timer = setInterval(tick, 450);



    return () => {

      clearInterval(timer);

      document.title = DEFAULT_TITLE;

    };

  }, [shouldAlert]);

}



export { DEFAULT_TITLE };

